import { IPhoneObject } from "@/Settings/types/Common/model";
import { placeholderChar as defaultPlaceholderChar } from "./constants";

const emptyArray: (string | RegExp)[] = [];

export function convertMaskToPlaceholder(mask = emptyArray, placeholderChar = defaultPlaceholderChar) {
	if (!isArray(mask)) {
		throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
	}

	if (mask.indexOf(placeholderChar) !== -1) {
		throw new Error(
			"Placeholder character must not be used as part of the mask. Please specify a character " +
				"that is not present in your mask as your placeholder character.\n\n" +
				`The placeholder character that was received is: ${JSON.stringify(placeholderChar)}\n\n` +
				`The mask that was received is: ${JSON.stringify(mask)}`
		);
	}

	return mask
		.map((char) => {
			return char instanceof RegExp ? placeholderChar : char;
		})
		.join("");
}

export function isArray(value: unknown) {
	return Array.isArray(value) || value instanceof Array;
}

export function isString(value: unknown) {
	return typeof value === "string" || value instanceof String;
}

export function isNumber(value: unknown) {
	return typeof value === "number" && !isNaN(value);
}

export function isNil(value: unknown) {
	return typeof value === "undefined" || value === null;
}

const strCaretTrap = "[]";
export function processCaretTraps(mask: string[]) {
	const indexes = [];

	let indexOfCaretTrap;
	while (((indexOfCaretTrap = mask.indexOf(strCaretTrap)), indexOfCaretTrap !== -1)) {
		// eslint-disable-line
		indexes.push(indexOfCaretTrap);

		mask.splice(indexOfCaretTrap, 1);
	}

	return { maskWithoutCaretTraps: mask, indexes };
}

export function convertStringMaskToRegexArray(mask = "") {
	if (!isString(mask)) {
		throw new Error("Text-mask:convertStringMaskToRegexArray; The mask property must be a string.");
	}

	return Array.from(mask, (char, idx) => {
		if (/\d/.test(char)) {
			if (idx > 0) {
				return /[\d*]/;
			}
			return /[1-9]/;
		} else {
			return char;
		}
	});
}

export const validatePhoneNumber = (phoneNumber: string, mask: string) => {
	const numericChars = phoneNumber?.replace(/\D/g, "");
	const maskNumericChars = mask?.replace(/\D/g, "");

	if (phoneNumber.includes("*")) {
		const charCount = phoneNumber.split("*").length - 1;
		return charCount === 1 && phoneNumber?.replace(/[^\d*]/g, "").length <= maskNumericChars?.length;
	}

	return numericChars?.length === maskNumericChars?.length;
};

export const validatePhoneNumbers = (phoneNumbers: string, mask = "") => {
	return phoneNumbers.split(",").every((num) => validatePhoneNumber(num.trim(), mask));
};

export const clearPhonesNumbers = (numbers: string[], specialNumbers: string[]) => {
	if (specialNumbers.length === 0) {
		return numbers;
	}
	// Only the numbers that do no start with any of the values that are the commodin
	return numbers.filter((numStr: string) => {
		const firstFourChars = numStr.replace(/\D/g, "").slice(0, 4);
		const hasPrefix = specialNumbers.some((prefix: string) => {
			return firstFourChars.replace(/\D/g, "").startsWith(prefix.replace(/\D/g, ""));
		});
		return !hasPrefix || numStr.replace(/\D/g, "").length >= 1;
	});
};

export const createMutationInput = (cleanedCommingNumbers: string[], phoneNumbers: IPhoneObject[], code = "") => {
	return {
		blacklistPhoneNumbers: [
			...cleanedCommingNumbers
				.filter((num) => {
					return !phoneNumbers.some((numObj) => {
						const number1 = (code + num).replace(/\D/g, "");
						const number2 = numObj.phoneNumber.replace(/\D/g, "");
						return number1.startsWith(number2);
					});
				})
				.map((num) => ({ phoneNumber: `${code} ${num}` })),
			// Remove all the numbers that start with with any of the numbers coming that have commodin
			...phoneNumbers.filter((phoneNumberObj) => {
				return !cleanedCommingNumbers.some((cleaned) => {
					return phoneNumberObj.phoneNumber.replace(/\D/g, "").startsWith((code + cleaned).replace(/\D/g, ""));
				});
			}),
		],
	};
};
